import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ 
  message = "正在加载...", 
  fullScreen = false 
}) => {
  const containerClass = fullScreen 
    ? "fixed inset-0 bg-background/80 backdrop-blur-sm" 
    : "w-full h-48";

  return (
    <div className={`${containerClass} flex items-center justify-center z-50`}>
      <div className="text-center space-y-4">
        <div className="relative">
          <div className="w-16 h-16 mx-auto bg-primary/10 rounded-full flex items-center justify-center animate-pulse">
            <Loader2 className="w-8 h-8 text-primary animate-spin" />
          </div>
        </div>
        <p className="text-sm text-muted-foreground animate-fade-in">
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;